import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from './app-config';
import { map, mapTo, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AppConfigService {

  private configuration: AppConfig = {};

  constructor(private httpClient: HttpClient) {
  }

  load(): Observable<void> {
    return this.httpClient.get('/assets/app.config.json')
      .pipe(
        map((configuration: any) => this.configuration = configuration || {}),
        mapTo(undefined),
      );
  }

  getValue(key: string, defaultValue?: any): any {
    type ObjectKey = keyof typeof  this.configuration;
    const keyToGet = key as ObjectKey;
    return  this.configuration[keyToGet] || defaultValue;
  }

}